import { Card, CardContent, Grid, Skeleton, Stack, Typography } from "@mui/material"
import { DirectionContext } from '../../../context/DirectionProvider';
import { useContext } from "react";

const RequestListSkeletonCard = () => {
    const direction = useContext(DirectionContext);
    return (
         <Card
            className='mb-3'
            sx={{
                cursor: 'pointer',
                borderLeft: '10px solid #ce2a1d',
                borderRight: '1px solid #eeeeee',
                borderRadius: '4px 0 0 4px',
                backgroundColor: 'white'
            }}
        >
            <CardContent
                className='p-2'
                role={undefined}
            >
                <Grid container columnSpacing={2}>
                    <Grid item md={0.6} sm={0.7} xs={1} margin={'auto'}>
                        <Skeleton variant="rectangular" width={18} height={18} sx={{ marginLeft: "2px" }} />
                    </Grid>
                    <Grid item md={9.3} sm={8.3} xs={9} className='_wg-dynamic-text'>
                        <Stack
                            flexWrap={'wrap'}
                            direction='row'
                            justifyContent='space-between'
                            alignItems='left'
                            gap={1}
                            className='p-0 m-0'
                        >
                            <Typography margin={0} variant='p' fontSize={14} className='_wg-dynamic-text'>
                                <span dir={direction.to} className='text-muted d-flex gap-2'>
                                    <Skeleton variant='text' width={60} />:
                                    <Skeleton variant='text' width={160} />
                                </span>
                            </Typography>

                            <Typography
                                margin={0}
                                fontSize={14}
                                variant='p'
                                className='p-0 m-0 _wg-dynamic-text'
                            >
                                <span dir={direction} className='text-muted d-flex gap-2'>
                                    <Skeleton variant='text' width={60} />:
                                    <Skeleton variant='text' width={40} />
                                </span>
                            </Typography>
                        </Stack>
                        <Stack
                            flexWrap={'wrap'}
                            direction='row'
                            justifyContent='space-between'
                            alignItems='left'
                            gap={1}
                            className='p-0 m-0 _wg-dynamic-text'
                        >
                            <Typography margin={0} variant='p' fontSize={14}>
                                <span dir={direction} className='text-muted d-flex gap-2'>
                                    <Skeleton variant='text' width={60} />:
                                    <Skeleton variant='text' width={100} />
                                </span>
                            </Typography>

                            <Typography margin={0} variant='p' fontSize={14}>
                                <span dir={direction} className='text-muted d-flex gap-2'>
                                    <Skeleton variant='text' width={60} />:
                                    <Skeleton variant='text' width={60} />
                                </span>
                            </Typography>
                            <Typography margin={0} variant='p' fontSize={14} className='_wg-dynamic-text'>
                                <span dir={direction} className='text-muted d-flex gap-2'>
                                    <Skeleton variant='text' width={80} />:
                                    <Skeleton variant='text' width={40} />
                                </span>
                            </Typography>
                        </Stack>{' '}
                    </Grid>
                    <Grid item md={2} sm={3} xs={2}
                        margin={'auto'}
                        textAlign={'right'}
                    >
                        <Skeleton variant='rectangular' width={100} height={32} sx={{
                            margin: "auto",
                            marginRight: "0",
                            borderRadius: "0.375rem"
                        }} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default RequestListSkeletonCard